export enum FilterType {
  None, Basic, AdvancedQuality, AdvancedQuantity, TopNQuality, TopNQuantity, Date , DateList
}
